// extracted by mini-css-extract-plugin
export default {"container":"External_container__tOS0X","content":"External_content__au88q"};